import React from 'react';
import Layout from "../components/Layout";
import TextBlock from "../components/TextBlock";
export default function page() {
    return /*#__PURE__*/ React.createElement(Layout, {
        title: "About Us",
        description: ""
    }, /*#__PURE__*/ React.createElement(TextBlock, {
        background: "/images/bg-lease-ipv4.jpg",
        backgroundColor: "#070b2c",
        color: "#ffffff",
        title: "About Us"
    }, "IPv4 Resources is a brand of Adjenet Networks SL"), /*#__PURE__*/ React.createElement("div", {
        className: "container mx-auto p-4"
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Adjenet Networks"), " is a legally registered company in Spain, the registration data is:"), /*#__PURE__*/ React.createElement("p", {
        className: "mt-4"
    }, "Registered in  ", /*#__PURE__*/ React.createElement("strong", null, "Registro Mercantil")), /*#__PURE__*/ React.createElement("h2", {
        className: "text-dark-primary font-bold font-ibm text-2xl my-2"
    }, "Registration Number"), /*#__PURE__*/ React.createElement("p", null, " B7663706"), /*#__PURE__*/ React.createElement("h2", {
        className: "text-dark-primary font-bold font-ibm text-2xl my-2"
    }, "Address"), /*#__PURE__*/ React.createElement("p", null, "Calle Albasanz 71"), /*#__PURE__*/ React.createElement("p", null, "28037 - MADRD"), /*#__PURE__*/ React.createElement("p", null, "SPAIN")));
}
